var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar_month_FILL0_wght400_GRAD0_opsz48",
    d: "M6.75,14A.769.769,0,0,1,6,13.25V5.5a.769.769,0,0,1,.75-.75h.813V4h.813v.75h4.25V4h.813v.75h.813A.769.769,0,0,1,15,5.5v7.75a.769.769,0,0,1-.75.75Zm0-.75h7.5V7.875H6.75Zm0-6.125h7.5V5.5H6.75Zm0,0v0ZM10.5,10a.491.491,0,1,1,.356-.144A.484.484,0,0,1,10.5,10Zm-2,0a.491.491,0,1,1,.356-.144A.484.484,0,0,1,8.5,10Zm4,0a.491.491,0,1,1,.356-.144A.484.484,0,0,1,12.5,10Zm-2,2a.491.491,0,1,1,.356-.144A.484.484,0,0,1,10.5,12Zm-2,0a.491.491,0,1,1,.356-.144A.484.484,0,0,1,8.5,12Zm4,0a.491.491,0,1,1,.356-.144A.484.484,0,0,1,12.5,12Z",
    transform: "translate(-6 -4)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCalendarIcon);
export default __webpack_public_path__ + "static/media/SmallCalendarIcon.addf7d1a470c5d8ff99127ccac2e5b19.svg";
export { ForwardRef as ReactComponent };